<template>
    <layouts-header></layouts-header>

    <breadcrumb :title="title" :text="text" :text1="text1" />

    <!-- Page Content -->
		<div class="content">
			<div class="container">

				<!-- Sort By -->
				<div class="row">
					<div class="col-lg-12">
						<div class="sortby-section">
							<div class="sorting-info">
								<div class="row d-flex align-items-center">
									<div class="col-xl-4 col-lg-3 col-sm-12 col-12">
										<div class="count-search">
											<p><span>400</span> venues are listed</p>
										</div>
									</div>
									<div class="col-xl-8 col-lg-9 col-sm-12 col-12">
										<div class="sortby-filter-group">
											<div class="grid-listview">
												<ul class="nav">
													<li>
														<span>View as</span>
													</li>
													<li>
														<router-link to="/coaches/listing-grid" class="active">
															<img src="@/assets/img/icons/sort-01.svg" alt="Icon">
														</router-link>
													</li>
													<li>
														<router-link to="/coaches/listing-list">
															<img src="@/assets/img/icons/sort-02.svg" alt="Icon">
														</router-link>
													</li>
													<li>
														<router-link to="/coaches/listing-map">
															<img src="@/assets/img/icons/sort-03.svg" alt="Icon">
														</router-link>
													</li>
												</ul>
											</div>
											<div class="sortbyset">
												<span class="sortbytitle">Sort By</span>
												<div class="sorting-select">
                                                    <vue-select :options="Sort" id="listingsort" placeholder="Relevance"/>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
				<!-- Sort By -->

				<!-- Listing Content -->
				<div class="row justify-content-center">

					<!-- Featured Item -->
					<div class="col-lg-4 col-md-6" v-for="item in ListingGrid" :key="item.id">
					    <div class="wrapper">
							<div class="listing-item listing-item-grid">										
								<div class="listing-img">
									<router-link to="/coaches/venue-details">
										<img :src="require(`@/assets/img/venues/${item.Image}`)" alt="Venue">
									</router-link>
									<div class="fav-item-venues">
										<span :class="item.Class">{{item.Badge}}</span>		
										<h5 class="tag tag-primary">{{item.Price}}<span>/hr</span></h5>
									</div>
								</div>										
								<div class="listing-content">
									<div class="list-reviews">							
										<div class="d-flex align-items-center">
											<span class="rating-bg">{{item.Rateing}}</span><span>{{item.Reviews}}</span> 
										</div>
										<a href="javascript:void(0)" class="fav-icon" @click="toggleSelected(item)"
                                        :class="{ selected: item.isSelected }">
											<i class="feather-heart"></i>
										</a>
									</div>	
									<h3 class="listing-title">
										<router-link to="/coaches/venue-details">{{item.Title}}</router-link>
									</h3>
									<div class="listing-details-group">
										<p>{{item.Content}}</p>
										<ul>
											<li>
												<span>
													<i class="feather-map-pin"></i>{{item.Location}}
												</span>
											</li>
											<li>
												<span>
													<i class="feather-calendar"></i>Next availablity : <span class="primary-text">{{item.Day}}</span>
												</span>
											</li>
										</ul>
									</div>
									<div class="listing-button">
										<div class="listing-venue-owner">
											<a class="navigation">
												<img :src="require(`@/assets/img/profiles/${item.Avatar}`)" alt="User">{{item.Name}}
											</a>												
										</div>
										<router-link to="/coaches/venue-details" class="user-book-now"><span><i class="feather-calendar me-2"></i></span>Book Now</router-link>
									</div>	
								</div>
							</div>
						</div>
					</div>
					<!-- /Featured Item -->

					<div class="col-12 text-center">
						<div class="more-details">
							<a href="javascript:void(0);" class="btn btn-load">Load More Coaches <img src="@/assets/img/icons/u_plus-square.svg" class="ms-2" alt="img"></a>
						</div>
					</div>
				</div>
				<!-- /Listing Content -->
			</div>

		</div>
		<!-- /Page Content -->

    <layout-footer></layout-footer>
</template>

<script>
import ListingGrid from '@/assets/json/listing.json'
export default {
    data() {
        return {
            ListingGrid: ListingGrid,
            title: 'Venue Grid Without Sidebar',
            text: 'Home',
            text1: 'Venue Grid Without Sidebar',
            Sort: ["Relevance", "Price"]
        }
    },
    methods: {
        toggleSelected(item) {
            item.isSelected = !item.isSelected;
        },
    },
}
</script>